import React from 'react'

import Card from '../card/Card'
import {  useFetchDiscountedProductsQuery } from '../../store/api/ProductSlice';

function LatestDiscountedProduct() {
  const { data, isLoading } = useFetchDiscountedProductsQuery();


const discountedData = data
  ?.filter(product =>
    product.price > 0 && product.originalPrice > product.price
  )
  .map(product => ({
    ...product,
    discountPercent: Math.round(
      ((product.originalPrice - product.price) / product.originalPrice) * 100
    ),
  }));

  
  return (

    <div
    id="discount"
    className="bg-gray-50 lg:py-16 py-10 mx-auto max-w-screen-2xl px-3 sm:px-10"
  >
    <div className="mb-10 flex justify-center">
      <div className="text-center w-full lg:w-2/5">
        <h2 className="text-xl lg:text-2xl mb-2 text-black font-semibold">
           Discounted Products
        </h2>
      </div>
    </div>
    <div className="flex">
        <div className="w-full">
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 xl:grid-cols-5 2xl:grid-cols-6 gap-2 md:gap-3 lg:gap-3 ">
        {!isLoading && discountedData?.slice(0,30).map((data, index) => (
       
              <Card key={index} data={data} />
            ))}
        </div>
        </div>
    </div>
  </div>
  )
}

export default LatestDiscountedProduct